const layout = {
  sidebar: {
    minWidth: 64,
    maxWidth: 200,
  },
  header: {
    height: 0,
  },
  aside: {
    width: 261,
  },
};
export default layout;
